

export const projects = [
    {
        leftSide : [
            {
                name: "Microsoft student partner",
                using: 'MERN Stack',
                host: 'https://msp-tech-club-egypt.netlify.app/',
                liveORgithub: true
            },
            {
                name: "Lucia's Restaurant Project",
                using: 'MERN Stack',
                host: 'https://lucia-restaurant-youssef.netlify.app/',
                liveORgithub: true
            },
            {
                name: 'Vintage Tech Project',
                using: 'MERN Stack',
                host: 'https://vintage-tech-youssef.netlify.app',
                liveORgithub: true
            },
            {
                name: 'Beach Resort Project ',
                using: 'ReactJS, Context API',
                host: 'https://beach-resort-youssef.netlify.app',
                liveORgithub: true
            },
            {
                name: 'CREATIVE AGENCY Project ',
                using: 'ReactJS, Hooks',
                host: 'https://creative-agency-youssef.netlify.app',
                liveORgithub: true
            },
            {
                name: 'Ultra Profile Project',
                using: 'ReactJS, Hooks',
                host: 'https://ultra-profile-youssef.netlify.app',
                liveORgithub: true
            },
            {
                name: 'CocktailDB Project',
                using: 'ReactJS, Hooks',
                host: 'https://the-cocktails-youssef.netlify.app',
                liveORgithub: true
            },
            {
                name: 'Memory Game',
                using: 'ReactJS, Hooks',
                host: 'https://memory-game-youssef.netlify.app',
                liveORgithub: true
            },
            {
                name: 'Counter and Show Data',
                using: 'ReactJS, Hooks, Redux',
                host: 'https://redux-count-get-products-youssef.netlify.app',
                liveORgithub: true
            },
            {
                name: 'Budget Calculator App',
                using: 'ReactJS, Hooks',
                host: 'https://budget-calculator-youssef.netlify.app',
                liveORgithub: true
            },
            {
                name: 'Reminder App',
                using: 'ReactJS, Hooks, Redux',
                host: 'https://reminder-app-youssef.netlify.app',
                liveORgithub: true
            },
            {
                name: 'Task Manager API',
                using: 'NodeJS, ExpressJS, MongoDB',
                host: 'https://github.com/YoussefRashad/Task-Manager-API',
                liveORgithub: false
            },
            {
                name: 'Market App',
                using: 'NodeJS, EJS, Express, MongoDB, Bootstrap4',
                host: 'https://github.com/YoussefRashad/Market.ejs',
                liveORgithub: false
            },

        ]
    },
    
    {
        rightSide:[

            {
                name: 'Creative Todo List',
                using: 'ReactJS, Redux, Hooks',
                host: 'https://creative-todo-list.netlify.app',
                liveORgithub: true
            },
            {
                name: 'DWH Decisions Making Report',
                using: 'Power BI',
                host: 'https://github.com/YoussefRashad/DWH-Decisions',
                liveORgithub: false
            },
            {
                name: 'Cryptography and Network Security',
                using: 'JavaSE, JavaFx',
                host: 'https://github.com/YoussefRashad/Cryptography-and-network-security',
                liveORgithub: false
            },
            {
                name: 'Library Management System',
                using: 'JavaSE, JavaFx',
                host: 'https://github.com/YoussefRashad/Library',
                liveORgithub: false
            },
            {
                name: 'Training Center System',
                using: 'JavaSE, JavaFx',
                host: 'https://github.com/YoussefRashad/Training-Center-System',
                liveORgithub: false
            },
            {
                name: 'Fashion Store Management System',
                using: 'JavaSE, JavaFx',
                host: 'https://github.com/YoussefRashad/Fashion-Store-Management-System',
                liveORgithub: false
            },
            {
                name: 'Train Ticket Reservation System',
                using: 'JavaSE, JavaFx',
                host: 'https://github.com/YoussefRashad/Train-Ticket-Reservation-System',
                liveORgithub: false
            },
            {
                name: 'Scheduling Algorithms Priority',
                using: 'JavaSE, JavaFx',
                host: 'https://github.com/YoussefRashad/Scheduling-Algorithms-Priority',
                liveORgithub: false
            },
            {
                name: 'Chat Application',
                using: 'JavaSE, JavaFx',
                host: 'https://github.com/YoussefRashad/Chat-Application',
                liveORgithub: false
            },
            {
                name: 'Electricity Billing System',
                using: 'JavaSE, JavaFx',
                host: 'https://github.com/YoussefRashad/ElectricityBillingSystem',
                liveORgithub: false
            },
            {
                name: 'Future-Tech ',
                using: 'HTML 5, CSS 3, JS, jQuery',
                host: 'https://github.com/YoussefRashad/Future-Technology',
                liveORgithub: false
            },
            {
                name: "Student's Affairs",
                using: 'C',
                host: 'https://github.com/YoussefRashad/Student-s-Affairs',
                liveORgithub: false
            },
            {
                name: 'Market App',
                using: 'C',
                host: 'https://github.com/YoussefRashad/Market',
                liveORgithub: false
            }
        ]
    }
]

export const TrainingExperience = [
    {
        leftSide:[
            'Software Enginner (intern) at TECH-HUB in Cairo from Dec 2020 to Present.',

            'Technical Advisor to the Board of Trust at Microsoft Student Partners at Microsoft Egypt from Sep 2020 to Present.',

            'Technical Vice President at Microsoft Student Partner -Helwan University at Microsoft Egypt from Aug 2019 to Sep 2020.',

            'IOT training from ITI, Aug 2019.',

            'AI analyst training from IBM Acadamic, Egypt Aug 2019',

            'Lecturer: Java SE Course in MSPs at Microsoft Egypt from Apr 2019 to June 2019.',

            'PR mebmer at Microsoft Student Partner -Helwan University at Microsoft Egypt from Feb 2019 to Aug 2019.'
        ]
    },
    {
        rightSide:[
            'Algorithms Training from SWE Program Jan2019 - Mar2019.',

            'ICPC FCI -Helwan Community from Oct 2018 to Jan 2020.',

            'Project Manager at Ain Shams iHub in 2018, Projects Title: Metal Detector & Vechile Robot.',

            'Technical mebmer at Microsoft Student Partner -Helwan University at Microsoft Egypt from Apr 2018 to Aug 2019.'
        ]
    }
]

export const workExperience = [
    {
        leftSide: [
            {
                title: 'Software Enginner at ThinKloud in Cairo from April 2021 to Present.',
                desc: 'Building Web & Mobile Apps using Node.js, React.js and React Native.'
            },
            {
                title: 'Back-End Enginner at EduAct in Cairo from March 2021 to Present.',
                desc: 'Building Web Apps using  Node.js(Nest.js), React.js.'
            },
            {
                title: 'Software Enginner (intern) at TECH-HUB from Dec 2020 to March 2021.',
                desc: 'Working in the SW industry, Reverse Enginnering and Building Web Apps. '
            },
        ]
    },
    {
        rightSide:[

            'AI analyst training from IBM Acadamic, Egypt Aug 2019',

            'IOT training from ITI, Aug 2019.',

            'Algorithms Training from SWE Program Jan2019 - Mar2019.',

        ]
    }
]

export const volunteeringWork = [
    {
        leftSide:[
            'Technical Advisor to the Board of Trust at Microsoft Student Partners at Microsoft Egypt from Sep 2020 to Present.',

            'Technical Vice President at Microsoft Student Partner -Helwan University at Microsoft Egypt from Aug 2019 to Sep 2020.',
            'Lecturer: Java SE Course in MSPs at Microsoft Egypt from Apr 2019 to June 2019.',
        ]
    },
    {
        rightSide: [
            'PR mebmer at Microsoft Student Partner -Helwan University at Microsoft Egypt from Feb 2019 to Aug 2019.',

            'ICPC FCI -Helwan Community from Oct 2018 to Jan 2020.',

            'Technical mebmer at Microsoft Student Partner -Helwan University at Microsoft Egypt from Apr 2018 to Aug 2019.'
        ]
    }
]

export const skills = [
    {
        leftSide:[
            {
                title: 'Programming',
                tech: 'Main (JS, Java, C/C++) & Very Good knowledge of many OOP concepts, Design Patterns, System Analysis, Data Structures, Analysis and Design of Algorithms.'
            },
            {
                title: 'Back End',
                tech: 'NodeJS, NestJS, AdonisJS, ExpressJS, JestJS, Strapi, Stripe, EJS, HBS, AJAX, JSON.'
            },
            {
                title: 'Front End',
                tech: 'ReactJS, ReactNative, MaterialUI, HTML5, CSS3, Bootstrap4.'
            }
        ]
    },
    {
        rightSide:[
            // {
            //     title: 'Data Structures and Algorithms',
            //     tech: 'Solved +300 programming problems on different online judges.'
            // },
            
            {
                title: 'Database',
                tech: 'SQL, NoSQL(MongoDB).'
            },
            {
                title: 'Tools',
                tech: 'Git and GitHub, VSCode, Code Blocks, Netbeans, Visual Studio.'
            },
            {
                title: 'Others',
                tech: 'Linux and Windows user, Java Swing, JavaFx.'
            },
        ]
    }
]

export const certification = [
    'NodeJS - The Complete Guide (incl. MVC, REST APIs, GraphQL) on Udemy in 2021.',
    'React Tutorial and Projects Course on Udemy in 2020.',
    'The Complete Node.js Developer Course on Udemy in 2020.',
    'RESTful API with HTTP and JS on Coursera in 2020.',
    'Object Oriented Programming using Java on Udemy in 2018.',
    'Linux with Ubuntu and CentOS on Udemy in 2018.',
    'Ubuntu Linux on Udemy in 2018.',
    'Excellent Achievement in Advanced C Language from SWE Program, in 2017.',
]